import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc71b1d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-mx-2" }
const _hoisted_4 = { class: "p-mt-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_7 = { class: "expiry-container" }
const _hoisted_8 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_10 = { style: {"white-space":"pre-line","word-break":"break-word","display":"block","width":"40vw"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No records found", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No transfer records for this stock item", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {"color":"#6b7280","font-size":"0.8rem"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  style: {"color":"#9ca3af"}
}
const _hoisted_17 = {
  key: 0,
  style: {"color":"#ef4444","font-size":"0.85rem"}
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning-content p-mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle" }),
  /*#__PURE__*/_createTextVNode(" WARNING: By Changing any numeric value listed in this screen will cause serious effects on accounting records of inventory. ")
], -1))
const _hoisted_23 = { style: {"display":"flex","flex-wrap":"wrap","align-items":"flex-start"} }
const _hoisted_24 = { style: {"flex":"1","padding":"0.5rem","align-self":"flex-start"} }
const _hoisted_25 = { class: "p-field" }
const _hoisted_26 = {
  key: 0,
  class: "p-error"
}
const _hoisted_27 = { class: "p-field" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "barcode" }, "Barcode", -1))
const _hoisted_29 = { class: "p-field" }
const _hoisted_30 = {
  key: 0,
  class: "p-error"
}
const _hoisted_31 = { style: {"flex":"1","padding":"0.5rem","align-self":"flex-start"} }
const _hoisted_32 = { class: "p-field" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Unit Qty ")
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 0,
  class: "p-error"
}
const _hoisted_36 = { class: "p-field" }
const _hoisted_37 = {
  key: 0,
  class: "p-error"
}
const _hoisted_38 = { class: "p-field" }
const _hoisted_39 = {
  key: 0,
  class: "p-error"
}
const _hoisted_40 = { style: {"flex":"1","padding":"0.5rem","align-self":"flex-start"} }
const _hoisted_41 = { class: "p-field" }
const _hoisted_42 = {
  key: 0,
  class: "p-error"
}
const _hoisted_43 = { class: "p-field" }
const _hoisted_44 = {
  key: 0,
  class: "p-error"
}
const _hoisted_45 = { class: "p-field" }
const _hoisted_46 = {
  key: 0,
  class: "p-error"
}
const _hoisted_47 = {
  key: 0,
  class: "p-mb-3",
  style: {"color":"#e67e22"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-lock" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Purchase Price & QTY locked", -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" - this batch has transfer history. Changing the purchase price and qty would cause accounting discrepancies across branches. ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Purchase Price locked", -1))
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" - this batch has transfer history. Changing the purchase price would cause accounting discrepancies across branches. ")
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Purchase Price & QTY locked", -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" - this batch has transfer history. Changing the purchase price and qty would cause accounting discrepancies across branches. ")
const _hoisted_55 = { class: "p-grid" }
const _hoisted_56 = { class: "p-col col-md-8" }
const _hoisted_57 = {
  key: 0,
  class: "p-float-label text-left"
}
const _hoisted_58 = {
  key: 1,
  class: "p-float-label text-left"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" (Free Units - Stock Loss) ")
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" (Stock Loss) ")
const _hoisted_64 = { key: 3 }
const _hoisted_65 = {
  key: 2,
  class: "p-float-label text-left"
}
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 3,
  class: "p-float-label text-left"
}
const _hoisted_69 = { class: "p-col col-md-4" }
const _hoisted_70 = { class: "confirmation-content" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" ?")
const _hoisted_73 = { class: "p-text-center p-p-3" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mb-3",
  style: {"font-size":"2rem","color":"#f59e0b","display":"block"}
}, null, -1))
const _hoisted_75 = { style: {"font-size":"1rem"} }
const _hoisted_76 = { class: "confirmation-content" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle p-mr-3",
  style: {"font-size":"2rem","color":"#e67e22"}
}, null, -1))
const _hoisted_78 = { class: "p-fluid" }
const _hoisted_79 = { class: "p-field" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Destination Branch *", -1))
const _hoisted_81 = { class: "p-field" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Notes", -1))
const _hoisted_83 = {
  key: 0,
  class: "p-mb-3"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Transfer:", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "From:", -1))
const _hoisted_86 = { class: "p-grid p-mb-3" }
const _hoisted_87 = { class: "p-col-4" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Transfer No:", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Date:", -1))
const _hoisted_93 = { class: "p-col-4" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "From:", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "To:", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Initiated By:", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Items", -1))
const _hoisted_101 = { key: 0 }
const _hoisted_102 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_103 = {
  key: 0,
  style: {"color":"#ef4444"}
}
const _hoisted_104 = { key: 1 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "History", -1))
const _hoisted_106 = {
  key: 0,
  style: {"font-size":"0.75rem","color":"#6b7280","display":"block"}
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No outgoing transfers found", -1))
const _hoisted_108 = { key: 0 }
const _hoisted_109 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_112 = { key: 2 }
const _hoisted_113 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_114 = { key: 3 }
const _hoisted_115 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_116 = { key: 4 }
const _hoisted_117 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_118 = { key: 5 }
const _hoisted_119 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_120 = { key: 6 }
const _hoisted_121 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_122 = { key: 7 }
const _hoisted_123 = { style: {"font-size":"0.75rem","color":"#6b7280","display":"block"} }
const _hoisted_124 = { key: 8 }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-text-center p-p-3" }, "No incoming transfers found", -1))
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_128 = { key: 1 }
const _hoisted_129 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_130 = { key: 2 }
const _hoisted_131 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_132 = { key: 3 }
const _hoisted_133 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_134 = { key: 4 }
const _hoisted_135 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_136 = { key: 5 }
const _hoisted_137 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_138 = { key: 6 }
const _hoisted_139 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_140 = { key: 7 }
const _hoisted_141 = { style: {"font-size":"0.75rem","color":"#6b7280"} }
const _hoisted_142 = { key: 8 }
const _hoisted_143 = { class: "p-fluid" }
const _hoisted_144 = { class: "p-field" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Decline Reason *", -1))
const _hoisted_146 = {
  key: 0,
  class: "p-error"
}
const _hoisted_147 = { class: "p-fluid" }
const _hoisted_148 = { class: "p-field" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Cancel Reason *", -1))
const _hoisted_150 = {
  key: 0,
  class: "p-error"
}
const _hoisted_151 = {
  key: 0,
  class: "p-mb-3",
  style: {"font-size":"0.9rem","color":"#374151"}
}
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Transfer:", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "To:", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_155 = {
  class: "p-mt-3",
  style: {"text-align":"right","font-size":"1rem","font-weight":"bold"}
}
const _hoisted_156 = {
  key: 0,
  class: "p-mb-3",
  style: {"font-size":"0.9rem","color":"#374151"}
}
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Original Transfer:", -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "From:", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {"color":"#e67e22","font-size":"0.85rem"},
  class: "p-mb-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle p-mr-1" }),
  /*#__PURE__*/_createTextVNode(" Submitting a return will immediately deduct entered quantities from your stock. Leave qty as 0 to skip an item. ")
], -1))
const _hoisted_160 = {
  key: 0,
  class: "p-error p-d-block"
}
const _hoisted_161 = { class: "p-mt-3 p-fluid" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Return Notes (optional)", -1))
const _hoisted_163 = {
  key: 0,
  class: "p-mb-3"
}
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Transfer:", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "To:", -1))
const _hoisted_166 = { key: 0 }
const _hoisted_167 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_168 = { class: "p-mt-3 p-fluid" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Confirmation Notes (optional)", -1))
const _hoisted_170 = {
  class: "p-mt-3",
  style: {"text-align":"right","font-size":"1rem","font-weight":"bold"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_Toolbar, null, {
          start: _withCtx(() => [
            _createVNode(_component_Breadcrumb, {
              home: _ctx.home,
              model: _ctx.items,
              class: "p-menuitem-text"
            }, null, 8, ["home", "model"])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.keyword,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                modelModifiers: { trim: true },
                placeholder: "Product Name, Generic Name, Batch No",
                style: {"width":"20rem"}
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                icon: "pi pi-search ",
                class: "p-button-success p-mr-1",
                onClick: _ctx.loadSearchData
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-times ",
                class: "p-button-info p-mr-1",
                onClick: _ctx.cleanSearchData
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.canTransferStock)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-arrow-up-right",
                    label: "Transfer",
                    class: "p-button-warning p-mr-1",
                    onClick: _ctx.openOutboundTransferList
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.canTransferStock)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    icon: "pi pi-arrow-down-left",
                    label: "Recieve",
                    class: "p-button-success",
                    onClick: _ctx.openInboundTransferList
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DataTable, {
            first: _ctx.goToFirstLink,
            "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.goToFirstLink) = $event)),
            firstModifiers: { sync: true },
            value: _ctx.lists,
            dataKey: "id",
            ref: "dt",
            lazy: true,
            paginator: _ctx.checkPagination,
            rows: _ctx.limit,
            totalRecords: _ctx.totalRecords,
            resizableColumns: true,
            columnResizeMode: "expand",
            responsiveLayout: "scroll",
            onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPage($event))),
            class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
            rowClass: _ctx.rowClass
          }, {
            empty: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Product Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_name), 1)
                ]),
                footer: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "reference",
                header: "Reference"
              }),
              _createVNode(_component_Column, { header: "Generic Name" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.generic_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Batch No" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.batch_no), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Barcode" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.barcode), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Purchased Qty" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(Number(slotProps.data.initial_qty).toFixed(0)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Current Qty" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(Number(slotProps.data.qty).toFixed(0)), 1)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(this.totalUnits), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Status" }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", {
                      class: "color-box",
                      style: _normalizeStyle({
                                    backgroundColor:
                                        slotProps.data.status == 'Active'
                                            ? 'green'
                                            : 'red',
                                })
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(slotProps.data.status), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: 'Purchased Price (Unit)' }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.purchase_price), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'MRP (Tax Inclusive) (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.mrp), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: 'Total Value (' + _ctx.currency + ')'
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.fixDigits(
                                    _ctx.calculateItemWorth(
                                        slotProps.data.purchase_price,
                                        slotProps.data.qty,
                                        slotProps.data.pack_size
                                    )
                                )), 1)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(this.worthAmt).toFixed(2)), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, { header: "Cust Disc %" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.discount_percentage) + " % ", 1)
                ]),
                _: 1
              }),
              (_ctx.taxNames[0] && _ctx.taxNames[0].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    header: _ctx.taxNames[0]?.taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_1) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1] && _ctx.taxNames[1].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    header: _ctx.taxNames[1]?.taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_2) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2] && _ctx.taxNames[2].show == 'true')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 2,
                    header: _ctx.taxNames[2]?.taxName + '(%)'
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.data.tax_3) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, { header: "Expiry Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatExpiry(slotProps.data.expiry_date)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Store Location" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.product_location), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Supplier" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.supplier_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Created Date" }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                exportable: false,
                header: "Action",
                class: "center-cell"
              }, {
                body: _withCtx((slotProps) => [
                  (_ctx.canEditStock && slotProps.data.ediable == true)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "pi pi-pencil",
                        class: "p-button-rounded p-button-success p-mr-2",
                        onClick: ($event: any) => (_ctx.editIem(slotProps.data))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.canEditStock)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "pi pi-eye",
                        class: "p-button-rounded p-button-success p-mr-2",
                        onClick: ($event: any) => (_ctx.showHistory(slotProps.data))
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["first", "value", "paginator", "rows", "totalRecords", "rowClass"])
        ])
      ])
    ]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
        dialogStatus: _ctx.paymentDialog,
        itemSource: this.stockAdj.type,
        restriction: 'No',
        paymentOptionType: 'Cashier',
        cashPayment: _ctx.cashPaymentOption,
        cardPayment: _ctx.cardPaymentOption,
        chequePayment: _ctx.chequePaymentOption,
        bankTransferPayment: _ctx.bankTransferPaymentOption,
        payLater: _ctx.payLaterOption,
        paySupplierCredit: _ctx.paySupplierCredit,
        dialogTitle: _ctx.paymentTitle,
        receivedTxt: 'Amount',
        customerID: this.item.profileID,
        customerName: this.item.profileName,
        customerType: this.item.profileType,
        closeConfirmation: true,
        supplierCreditAmount: _ctx.supplierCreditAmount,
    },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.stockHistoryDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stockHistoryDialog) = $event)),
      style: { width: '100vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.stockHistoryDialogTitle), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_TabView, null, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, { header: "Stock Adjustments" }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  first: _ctx.goToSubFirstLink,
                  "onUpdate:first": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.goToSubFirstLink) = $event)),
                  firstModifiers: { sync: true },
                  value: _ctx.stockHistory,
                  lazy: true,
                  paginator: _ctx.checkSubPagination,
                  rows: _ctx.limit,
                  totalRecords: _ctx.totalSubRecords,
                  scrollable: true,
                  onPage: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubHistoryPage($event))),
                  class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
                }, {
                  empty: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "changes",
                      header: "Changes",
                      style: {"width":"40vw","min-width":"40vw"}
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_DataTable, {
                            value: slotProps.data.changes,
                            lazy: true
                          }, {
                            empty: _withCtx(() => [
                              _hoisted_11
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "field",
                                header: "Field"
                              }),
                              _createVNode(_component_Column, {
                                field: "old",
                                header: "Old Value"
                              }),
                              _createVNode(_component_Column, {
                                field: "newValue",
                                header: "New Value"
                              })
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "user.name",
                      header: "User",
                      style: {"width":"10%"}
                    }),
                    _createVNode(_component_Column, {
                      field: "created_at",
                      header: "Created At"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDateTime(slotProps.data.created_at)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "reason",
                      header: "Reason"
                    }),
                    _createVNode(_component_Column, {
                      field: "description",
                      header: "Description"
                    }),
                    _createVNode(_component_Column, {
                      field: "stock_adjustment_receipt.receipt_no",
                      header: "Receipt No"
                    })
                  ]),
                  _: 1
                }, 8, ["first", "value", "paginator", "rows", "totalRecords"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, { header: "Transfer History" }, {
              default: _withCtx(() => [
                _createVNode(_component_DataTable, {
                  value: _ctx.stockTransferHistory,
                  class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
                }, {
                  empty: _withCtx(() => [
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { header: "Transfer No" }, {
                      body: _withCtx((s) => [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.viewTransferDetailById(s.data.transfer_id)), ["prevent"]),
                          style: {"color":"#3b82f6","text-decoration":"underline"}
                        }, _toDisplayString(s.data.transfer_no), 9, _hoisted_13)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Direction" }, {
                      body: _withCtx((s) => [
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                                background: s.data.direction === 'OUT' ? '#ef4444' : '#10b981',
                                color:'#fff', padding:'2px 8px', borderRadius:'4px', fontSize:'0.8rem'
                            })
                        }, _toDisplayString(s.data.direction === 'OUT' ? 'OUT' : 'IN'), 5)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "From Branch" }, {
                      body: _withCtx((s) => [
                        _createTextVNode(_toDisplayString(s.data.from_branch_name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "To Branch" }, {
                      body: _withCtx((s) => [
                        _createTextVNode(_toDisplayString(s.data.to_branch_name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Sent Qty" }, {
                      body: _withCtx((s) => [
                        _createTextVNode(_toDisplayString(Number(s.data.sent_qty).toFixed(0)) + " ", 1),
                        _createElementVNode("span", _hoisted_14, " (P:" + _toDisplayString(Number(s.data.sent_paid_qty).toFixed(0)) + " F:" + _toDisplayString(Number(s.data.sent_free_qty).toFixed(0)) + ") ", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Received Qty" }, {
                      body: _withCtx((s) => [
                        (s.data.received_qty != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(Number(s.data.received_qty).toFixed(0)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, "Pending"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Discrepancy" }, {
                      body: _withCtx((s) => [
                        (s.data.missing_qty > 0 || s.data.damaged_qty > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Missing: " + _toDisplayString(Number(s.data.missing_qty).toFixed(0)) + " Damaged: " + _toDisplayString(Number(s.data.damaged_qty).toFixed(0)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Purchase Price" }, {
                      body: _withCtx((s) => [
                        _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.effective_cost).toFixed(2)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Status" }, {
                      body: _withCtx((s) => [
                        _createElementVNode("span", {
                          style: _normalizeStyle({
                                background: _ctx.transferStatusColor(s.data.transfer_status),
                                color:'#fff', padding:'2px 6px', borderRadius:'4px', fontSize:'0.8rem'
                            })
                        }, _toDisplayString(s.data.transfer_status), 5)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Transfer Date" }, {
                      body: _withCtx((s) => [
                        _createTextVNode(_toDisplayString(_ctx.formatExpiry(s.data.transfer_date)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Actioned By" }, {
                      body: _withCtx((s) => [
                        (s.data.direction === 'OUT')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(s.data.initiated_by), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(s.data.received_by ?? '-'), 1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.productDialog,
      "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.productDialog) = $event)),
      style: { width: '50vw' },
      maximizable: true,
      modal: true,
      position: "top",
      class: "p-fluid p-m-0 p-p-3",
      closeOnEscape: false,
      onHide: _ctx.onProductDialogHide
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            (_ctx.adjustedPrice() !== 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_57, " Total Purchase Price: " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.state.packPurchase * _ctx.state.unitQty)), 1))
              : _createCommentVNode("", true),
            ((_ctx.state.typeId === 1 && _ctx.adjustedPrice() !== 0 && !(_ctx.isQtyChanged() && _ctx.isPriceChanged()))
                            || ((_ctx.state.typeId === 2 || _ctx.state.typeId === 3 || _ctx.state.typeId === 4) && _ctx.isQtyChanged()))
              ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                  _createTextVNode(" Total Adjusted Price: " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.adjustedPriceDisplay)) + " ", 1),
                  (_ctx.state.typeId === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.adjustedPrice() > 0 ? '(Payable)' : '(Receivable)'), 1))
                    : (_ctx.state.typeId === 4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, " (Free Units - Stock Found) "))
                      : (_ctx.state.typeId === 2 || _ctx.state.typeId === 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                            (_ctx.paidLostQty === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_62
                                ], 64))
                              : (_ctx.freeLostQty > 0 && _ctx.paidLostQty > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" (" + _toDisplayString(_ctx.paidLostQty) + " paid unit(s) - " + _toDisplayString(_ctx.freeLostQty) + " free unit(s) excluded) ", 1)
                                  ], 64))
                                : (_ctx.freeLostQty === 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _hoisted_63
                                    ], 64))
                                  : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString((_ctx.state.packPurchase > _ctx.state.packOldPurchase) ? '(Payable)' : '(Receivable)'), 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isQtyChanged() && _ctx.isPriceChanged())
              ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                  _createTextVNode(" Qty Change Value: " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(Math.abs((_ctx.state.unitQty - _ctx.state.oldUnitQty) * _ctx.state.packPurchase))) + " ", 1),
                  (_ctx.state.typeId === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString((_ctx.state.unitQty > _ctx.state.oldUnitQty) ? '(Payable)' : '(Receivable)'), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_67, " (Stock " + _toDisplayString((_ctx.state.unitQty > _ctx.state.oldUnitQty) ? 'Gain' : 'Loss') + " ) ", 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPriceChanged())
              ? (_openBlock(), _createElementBlock("span", _hoisted_68, " Price Correction: " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(Math.abs(_ctx.state.packPurchase - _ctx.state.packOldPurchase) * _ctx.state.paidUnitsRemaining)) + " " + _toDisplayString((_ctx.state.packPurchase > _ctx.state.packOldPurchase) ? '(Payable)' : '(Receivable)'), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_69, [
            (_ctx.checkChanges())
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "submit",
                  label: "Save",
                  icon: "pi pi-check",
                  class: "p-button-primary",
                  onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              type: "button",
              label: "Close",
              class: "p-button-danger",
              onClick: _withModifiers(_ctx.closeEditDialog, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", {
                for: "TypeId",
                class: _normalizeClass({
                        'p-error': _ctx.v$.typeId.$invalid && _ctx.submitted,
                    })
              }, "Reason *", 2),
              _createVNode(_component_Dropdown, {
                modelValue: _ctx.v$.typeId.$model,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.typeId.$model) = $event)),
                onChange: _ctx.onReasonChange,
                options: _ctx.stockAdjustmentTypes,
                placeholder: "Select a Reason",
                filter: true,
                optionLabel: "name",
                optionValue: "id",
                class: _normalizeClass({ 'p-invalid': _ctx.v$.typeId.$invalid && _ctx.submitted })
              }, null, 8, ["modelValue", "onChange", "options", "class"]),
              (
                        (_ctx.v$.typeId.$invalid && _ctx.submitted) ||
                        _ctx.v$.typeId.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(_ctx.v$.typeId.$silentErrors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_InputText, {
                id: "barcode",
                modelValue: _ctx.item.barcode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.barcode) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", {
                for: "batchNo",
                class: _normalizeClass({ 'p-error': _ctx.v$.batchNo.$invalid && _ctx.submitted })
              }, "Batch No", 2),
              _createVNode(_component_InputText, {
                id: "batchNo",
                modelValue: _ctx.v$.batchNo.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.batchNo.$model) = $event)),
                class: _normalizeClass({
                        'p-invalid': _ctx.v$.batchNo.$invalid && _ctx.submitted,
                    })
              }, null, 8, ["modelValue", "class"]),
              (
                        (_ctx.v$.batchNo.$invalid && _ctx.submitted) ||
                        _ctx.v$.batchNo.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString(_ctx.v$.batchNo.required.$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", {
                for: "unitQty",
                class: _normalizeClass({ 'p-error': _ctx.v$.unitQty.$invalid && _ctx.submitted })
              }, [
                _hoisted_33,
                false
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, " - Current:" + _toDisplayString(this.state.oldUnitQty), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode(_component_InputNumber, {
                id: "unitQty",
                modelValue: _ctx.v$.unitQty.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.unitQty.$model) = $event)),
                onInput: _cache[10] || (_cache[10] = ($event: any) => {_ctx.setValueRealtime(_ctx.v$.unitQty, $event); _ctx.v$.unitQty.$touch()}),
                onBlur: _ctx.validateQtyOnBlur,
                class: _normalizeClass({
                            'p-invalid': _ctx.v$.unitQty.$invalid && (_ctx.submitted || _ctx.v$.unitQty.$dirty),
                        }),
                useGrouping: false,
                disabled: _ctx.isQtyDisabled
              }, null, 8, ["modelValue", "onBlur", "class", "disabled"]),
              (
                        (_ctx.v$.unitQty.$invalid && (_ctx.submitted || _ctx.v$.unitQty.$dirty)) ||
                        _ctx.v$.unitQty.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_ctx.v$.unitQty.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", {
                for: "packPurchase",
                class: _normalizeClass({
                        'p-error': _ctx.v$.packPurchase.$invalid && _ctx.submitted,
                    })
              }, "Unit Purchase Price", 2),
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "packPurchase",
                modelValue: _ctx.v$.packPurchase.$model,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.packPurchase.$model) = $event)),
                onInput: _cache[12] || (_cache[12] = ($event: any) => {_ctx.setValueRealtime(_ctx.v$.packPurchase, $event); _ctx.v$.packPurchase.$touch()}),
                class: _normalizeClass({
                            'p-invalid': _ctx.v$.packPurchase.$invalid && (_ctx.submitted || _ctx.v$.packPurchase.$dirty),
                        }),
                disabled: _ctx.isPriceDisabled
              }, null, 8, ["modelValue", "class", "disabled"]),
              (
                        (_ctx.v$.packPurchase.$invalid && (_ctx.submitted || _ctx.v$.packPurchase.$dirty)) ||
                        _ctx.v$.packPurchase.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(_ctx.v$.packPurchase.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", {
                for: "mRP",
                class: _normalizeClass({ 'p-error': _ctx.v$.mRP.$invalid && _ctx.submitted })
              }, "MRP (Tax Inclusive)", 2),
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "mRP",
                modelValue: _ctx.v$.mRP.$model,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.mRP.$model) = $event)),
                onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setValueRealtime(_ctx.v$.mRP, $event))),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.mRP.$invalid && (_ctx.submitted || _ctx.v$.mRP.$dirty) })
              }, null, 8, ["modelValue", "class"]),
              (
                        (_ctx.v$.mRP.$invalid && (_ctx.submitted || _ctx.v$.mRP.$dirty)) ||
                        _ctx.v$.mRP.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_39, _toDisplayString(_ctx.v$.mRP.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", {
                for: "disc",
                class: _normalizeClass({ 'p-error': _ctx.v$.disc.$invalid && _ctx.submitted })
              }, "Cust. Discount %", 2),
              _createVNode(_component_InputNumber, {
                mode: "decimal",
                maxFractionDigits: 2,
                minFractionDigits: 2,
                id: "disc",
                modelValue: _ctx.v$.disc.$model,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.disc.$model) = $event)),
                onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setValueRealtime(_ctx.v$.disc, $event))),
                class: _normalizeClass({ 'p-invalid': _ctx.v$.disc.$invalid && (_ctx.submitted || _ctx.v$.disc.$dirty) }),
                useGrouping: false
              }, null, 8, ["modelValue", "class"]),
              (
                        (_ctx.v$.disc.$invalid && (_ctx.submitted || _ctx.v$.disc.$dirty)) ||
                        _ctx.v$.disc.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_42, _toDisplayString(_ctx.v$.disc.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", {
                for: "expiryDate",
                class: _normalizeClass({
                        'p-error': _ctx.v$.expiryDate.$invalid && _ctx.submitted,
                    })
              }, "Expiry Date", 2),
              _createVNode(_component_Calendar, {
                id: "expiryDate",
                modelValue: _ctx.v$.expiryDate.$model,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.expiryDate.$model) = $event)),
                selectionMode: "single",
                dateFormat: "dd-mm-yy",
                manualInput: false,
                minDate: _ctx.getDateAfterMonths(0, 1),
                maxDate: new Date(3000, 0, 1)
              }, null, 8, ["modelValue", "minDate", "maxDate"]),
              (
                        (_ctx.v$.expiryDate.$invalid && _ctx.submitted) ||
                        _ctx.v$.expiryDate.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_ctx.v$.expiryDate.$silentErrors[0].$message), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", {
                for: "Description",
                class: _normalizeClass({
                        'p-error': _ctx.v$.description.$invalid && _ctx.submitted,
                    })
              }, "Description *", 2),
              _createVNode(_component_InputText, {
                id: "Description",
                modelValue: _ctx.state.description,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.description) = $event)),
                class: _normalizeClass({
                        'p-invalid': _ctx.v$.description.$invalid && _ctx.submitted,
                    })
              }, null, 8, ["modelValue", "class"]),
              (
                        (_ctx.v$.description.$invalid && _ctx.submitted) ||
                        _ctx.v$.description.$pending.$response
                    )
                ? (_openBlock(), _createElementBlock("small", _hoisted_46, _toDisplayString(_ctx.v$.description.$silentErrors[0].$message), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        ((_ctx.hasActiveTransfer || _ctx.hasReceivedTransfer) && _ctx.state.typeId === 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_47, [
              _hoisted_48,
              (_ctx.hasActiveTransfer && _ctx.hasReceivedTransfer)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_49,
                    _hoisted_50
                  ], 64))
                : (_ctx.hasActiveTransfer)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_51,
                      _hoisted_52
                    ], 64))
                  : (_ctx.hasReceivedTransfer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _hoisted_53,
                        _hoisted_54
                      ], 64))
                    : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteConfirmationDialog,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.deleteConfirmationDialog) = $event)),
      style: { width: '450px' },
      header: "Confirm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-success",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.deleteConfirmationDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes",
          icon: "pi pi-check",
          class: "p-button-danger",
          onClick: _ctx.handleClick
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createElementVNode("span", null, [
            _createTextVNode("Are you sure to " + _toDisplayString(_ctx.item.status === "Active" ? "Reinstate" : "Delete") + " ", 1),
            _createElementVNode("b", null, _toDisplayString(_ctx.state.productName), 1),
            _hoisted_72
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.confirmAdjDialog,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.confirmAdjDialog) = $event)),
      style: { width: '800px' },
      header: "Confirm Adjustment",
      modal: true,
      closeOnEscape: false,
      onShow: _ctx.onConfirmDialogShow,
      onHide: _ctx.onConfirmDialogHide
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          class: "p-button-danger",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.confirmAdjDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Yes, Proceed",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: _ctx.proceedAdjSave
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_73, [
          _hoisted_74,
          _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.confirmAdjMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onShow", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.validationPopup,
      "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.validationPopup) = $event)),
      style: { width: '600px' },
      header: "Notice"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Close",
          icon: "pi pi-times",
          class: "p-button-danger",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.validationPopup = false)),
          autoFocus: ""
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_76, [
          _hoisted_77,
          _createElementVNode("span", null, _toDisplayString(_ctx.validationPopupMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.transferDialog,
      "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.transferDialog) = $event)),
      style: {width:'60vw'},
      header: "Initiate Stock Transfer",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.transferDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Initiate Transfer",
          icon: "pi pi-send",
          class: "p-button-primary",
          onClick: _ctx.submitTransfer
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.transferState.toBranchId,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.transferState.toBranchId) = $event)),
              options: _ctx.branchList,
              optionLabel: "name",
              optionValue: "id",
              placeholder: "Select destination branch"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _hoisted_82,
            _createVNode(_component_InputText, {
              modelValue: _ctx.transferState.notes,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.transferState.notes) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_DataTable, {
            value: _ctx.transferState.items,
            class: "p-datatable-sm p-mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "product_name",
                header: "Product"
              }),
              _createVNode(_component_Column, {
                field: "batch_no",
                header: "Batch No"
              }),
              _createVNode(_component_Column, { header: "Available Qty" }, {
                body: _withCtx((s) => [
                  _createTextVNode(_toDisplayString(Number(s.data.available_qty).toFixed(0)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Transfer Qty *" }, {
                body: _withCtx((s) => [
                  _createVNode(_component_InputNumber, {
                    modelValue: s.data.qty,
                    "onUpdate:modelValue": ($event: any) => ((s.data.qty) = $event),
                    min: 1,
                    max: s.data.available_qty,
                    useGrouping: false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "purchase_price",
                header: "Purchase Price"
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.transferReceiveDialog,
      "onUpdate:visible": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.transferReceiveDialog) = $event)),
      style: { width: '100vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Receive & Validate Transfer",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.transferReceiveDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Confirm Receipt",
          icon: "pi pi-check",
          class: "p-button-success",
          onClick: _ctx.submitReceive
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.selectedTransfer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
              _hoisted_84,
              _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.transfer_no) + "  |  ", 1),
              _hoisted_85,
              _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.from_branch?.name), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataTable, {
          value: _ctx.receiveItems,
          class: "p-datatable-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "product_name",
              header: "Product"
            }),
            _createVNode(_component_Column, {
              field: "batch_no",
              header: "Batch No"
            }),
            _createVNode(_component_Column, { header: "Dispatched Qty" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.sent_qty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Missing Qty" }, {
              body: _withCtx((s) => [
                _createVNode(_component_InputNumber, {
                  modelValue: s.data.missing_qty,
                  "onUpdate:modelValue": ($event: any) => ((s.data.missing_qty) = $event),
                  min: 0,
                  max: s.data.sent_qty - (Number(s.data.damaged_qty) || 0),
                  useGrouping: false,
                  style: {"width":"7rem"},
                  onInput: (e) => { s.data.missing_qty = e.value ?? 0; _ctx.recalcReceived(s.data, 'missing'); }
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Damaged Qty" }, {
              body: _withCtx((s) => [
                _createVNode(_component_InputNumber, {
                  modelValue: s.data.damaged_qty,
                  "onUpdate:modelValue": ($event: any) => ((s.data.damaged_qty) = $event),
                  min: 0,
                  max: s.data.sent_qty - (Number(s.data.missing_qty) || 0),
                  useGrouping: false,
                  style: {"width":"7rem"},
                  onInput: (e) => { s.data.damaged_qty = e.value ?? 0; _ctx.recalcReceived(s.data, 'damaged'); }
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Received Qty" }, {
              body: _withCtx((s) => [
                _createElementVNode("b", null, _toDisplayString(Number(s.data.received_qty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Notes" }, {
              body: _withCtx((s) => [
                _createVNode(_component_InputText, {
                  modelValue: s.data.notes,
                  "onUpdate:modelValue": ($event: any) => ((s.data.notes) = $event),
                  placeholder: "Discrepancy reason...",
                  class: _normalizeClass({
                            'p-invalid': (Number(s.data.missing_qty) > 0 || Number(s.data.damaged_qty) > 0) && !s.data.notes?.trim()
                        })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.transferDetailDialog,
      "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.transferDetailDialog) = $event)),
      style: { width: '100vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Transfer Detail",
      modal: true
    }, {
      default: _withCtx(() => [
        (_ctx.selectedTransfer)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _hoisted_88,
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.transfer_no), 1),
                  _hoisted_89,
                  _hoisted_90,
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.status), 1),
                  _hoisted_91,
                  _hoisted_92,
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.transfer_date), 1)
                ]),
                _createElementVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.from_branch?.name), 1),
                  _hoisted_95,
                  _hoisted_96,
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.to_branch?.name), 1),
                  _hoisted_97,
                  _hoisted_98,
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTransfer.initiated_by_user?.name), 1),
                  _hoisted_99
                ])
              ]),
              _hoisted_100,
              _createVNode(_component_DataTable, {
                value: _ctx.selectedTransfer.items,
                class: "p-datatable-sm p-mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "Product" }, {
                    body: _withCtx((s) => [
                      _createTextVNode(_toDisplayString(s.data.product?.product_name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "batch_no",
                    header: "Batch No"
                  }),
                  _createVNode(_component_Column, { header: "Sent" }, {
                    body: _withCtx((s) => [
                      _createTextVNode(_toDisplayString(Number(s.data.sent_qty).toFixed(0)) + " (P:" + _toDisplayString(Number(s.data.sent_paid_qty).toFixed(0)) + " F:" + _toDisplayString(Number(s.data.sent_free_qty).toFixed(0)) + ") ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Received" }, {
                    body: _withCtx((s) => [
                      (s.data.received_qty != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(Number(s.data.received_qty).toFixed(0)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_102, "Pending"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Missing / Damaged" }, {
                    body: _withCtx((s) => [
                      (s.data.missing_qty > 0 || s.data.damaged_qty > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_103, " M:" + _toDisplayString(Number(s.data.missing_qty).toFixed(0)) + " D:" + _toDisplayString(Number(s.data.damaged_qty).toFixed(0)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_104, "-"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Purchase Price" }, {
                    body: _withCtx((s) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.effective_cost).toFixed(2)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Sub Total" }, {
                    body: _withCtx((s) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.sub_total).toFixed(2)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _hoisted_105,
              _createVNode(_component_DataTable, {
                value: _ctx.selectedTransfer.history,
                class: "p-datatable-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "Action" }, {
                    body: _withCtx((s) => [
                      _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryAction(s.data.action)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "User" }, {
                    body: _withCtx((s) => [
                      _createElementVNode("span", null, _toDisplayString(s.data.user?.name), 1),
                      (s.data.user?.branch_id && s.data.user.branch_id !== _ctx.currentStoreID)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_106, " (" + _toDisplayString(s.data.user?.branch?.name ?? s.data.user?.branch?.code) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Notes",
                    field: "notes"
                  }),
                  _createVNode(_component_Column, { header: "Timestamp" }, {
                    body: _withCtx((s) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDateTime(s.data.created_at)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.outboundDialog,
      "onUpdate:visible": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.outboundDialog) = $event)),
      style: { width: '100vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Outgoing Transfers",
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "p-mb-2" }, {
          start: _withCtx(() => [
            _createVNode(_component_Button, {
              label: "Create Transfer",
              icon: "pi pi-plus",
              class: "p-button-primary",
              onClick: _ctx.openCreateTransferTab
            }, null, 8, ["onClick"])
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.outboundStatusFilter,
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.outboundStatusFilter) = $event)),
              options: _ctx.transferStatusOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "All Statuses",
              style: {"width":"160px"},
              onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.loadOutboundList(0))),
              class: "p-mr-1"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.transferKeyword,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.transferKeyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Transfer No",
              style: {"width":"15rem"},
              onKeyup: _cache[37] || (_cache[37] = _withKeys(($event: any) => (_ctx.loadOutboundList(0)), ["enter"]))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-primary p-mr-1 p-ml-1",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.loadOutboundList(0)))
            }),
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-info",
              onClick: _cache[39] || (_cache[39] = ($event: any) => {_ctx.transferKeyword = ''; _ctx.loadOutboundList(0)})
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DataTable, {
          value: _ctx.outboundTransfers,
          lazy: true,
          first: _ctx.outboundFirst,
          "onUpdate:first": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.outboundFirst) = $event)),
          paginator: true,
          rows: _ctx.transferLimit,
          totalRecords: _ctx.outboundTotal,
          onPage: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onOutboundPage($event))),
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_107
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "transfer_no",
              header: "Transfer No"
            }),
            _createVNode(_component_Column, { header: "To Branch" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(s.data.to_branch?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Status" }, {
              body: _withCtx((s) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({
                        background: _ctx.transferStatusColor(s.data.status),
                        color:'#fff', padding:'2px 6px', borderRadius:'4px', fontSize:'0.8rem'
                    })
                }, _toDisplayString(s.data.status), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Items" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(s.data.merged_item_count ?? s.data.items?.length ?? 0) + " item(s)", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Cost Value" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.total_cost_value).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Transfer Date" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(_ctx.formatExpiry(s.data.transfer_date)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Actioned By" }, {
              body: _withCtx((s) => [
                (s.data.status === 'Cancelled' && s.data.cancel_history)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                      _createElementVNode("span", null, _toDisplayString(s.data.cancel_history.user?.name ?? '-'), 1),
                      _createElementVNode("span", _hoisted_109, " (" + _toDisplayString(s.data.cancel_history.action === 'CancelledByReceiver' ? s.data.to_branch?.name : s.data.from_branch?.name) + ") ", 1)
                    ]))
                  : (s.data.status === 'Requested' && s.data.initiated_by_user)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_110, [
                        _createElementVNode("span", null, _toDisplayString(s.data.initiated_by_user.name), 1),
                        _createElementVNode("span", _hoisted_111, " (" + _toDisplayString(s.data.from_branch?.name) + ") ", 1)
                      ]))
                    : (s.data.status === 'InTransit' && s.data.dispatched_by_user)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_112, [
                          _createElementVNode("span", null, _toDisplayString(s.data.dispatched_by_user.name), 1),
                          _createElementVNode("span", _hoisted_113, " (" + _toDisplayString(s.data.from_branch?.name) + ") ", 1)
                        ]))
                      : (s.data.status === 'Discrepancy' && s.data.received_by_user)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_114, [
                            _createElementVNode("span", null, _toDisplayString(s.data.received_by_user.name), 1),
                            _createElementVNode("span", _hoisted_115, " (" + _toDisplayString(s.data.to_branch?.name) + ") ", 1)
                          ]))
                        : (s.data.status === 'Declined' && s.data.declined_by_user)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_116, [
                              _createElementVNode("span", null, _toDisplayString(s.data.declined_by_user.name), 1),
                              _createElementVNode("span", _hoisted_117, " (" + _toDisplayString(s.data.to_branch?.name) + ") ", 1)
                            ]))
                          : (s.data.status === 'Approved' && s.data.approved_by_user)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_118, [
                                _createElementVNode("span", null, _toDisplayString(s.data.approved_by_user.name), 1),
                                _createElementVNode("span", _hoisted_119, " (" + _toDisplayString(s.data.to_branch?.name) + ") ", 1)
                              ]))
                            : (s.data.status === 'Completed' && s.data.completed_history?.user)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                                  _createElementVNode("span", null, _toDisplayString(s.data.completed_history.user.name), 1),
                                  _createElementVNode("span", _hoisted_121, " (" + _toDisplayString(s.data.completed_history.user.branch?.name ?? s.data.from_branch?.name) + ") ", 1)
                                ]))
                              : (s.data.initiated_by_user)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_122, [
                                    _createElementVNode("span", null, _toDisplayString(s.data.initiated_by_user.name), 1),
                                    _createElementVNode("span", _hoisted_123, " (" + _toDisplayString(s.data.from_branch?.name) + ") ", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_124, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Actions" }, {
              body: _withCtx((s) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-eye",
                  class: "p-button-rounded p-button-info p-mr-1",
                  title: "View Detail",
                  onClick: ($event: any) => (_ctx.viewTransferDetail(s.data))
                }, null, 8, ["onClick"]),
                (s.data.status === 'Requested')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-danger p-mr-1",
                      title: "Cancel Request",
                      onClick: ($event: any) => (_ctx.cancelTransfer(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'Approved')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "pi pi-send",
                      class: "p-button-rounded p-button-success p-mr-1",
                      title: "Dispatch Stock",
                      onClick: ($event: any) => (_ctx.openDispatchDialog(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'ReturnApproved')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      icon: "pi pi-send",
                      class: "p-button-rounded p-button-warning p-mr-1",
                      title: "Dispatch Return",
                      onClick: ($event: any) => (_ctx.dispatchReturnTransfer(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'Approved')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 3,
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-danger p-mr-1",
                      title: "Cancel Transfer",
                      onClick: ($event: any) => (_ctx.cancelTransfer(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'InTransit')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 4,
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-danger p-mr-1",
                      title: "Cancel Transfer",
                      onClick: ($event: any) => (_ctx.cancelTransfer(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'Discrepancy')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 5,
                      icon: "pi pi-check-circle",
                      class: "p-button-rounded p-button-warning p-mr-1",
                      title: "Complete Discrepancy",
                      onClick: ($event: any) => (_ctx.completeTransfer(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "first", "rows", "totalRecords"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.inboundDialog,
      "onUpdate:visible": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.inboundDialog) = $event)),
      style: { width: '100vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Incoming Transfers",
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "p-mb-2" }, {
          end: _withCtx(() => [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.inboundStatusFilter,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.inboundStatusFilter) = $event)),
              options: _ctx.transferStatusOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "All Statuses",
              style: {"width":"160px"},
              onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.loadInboundList(0))),
              class: "p-mr-1"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_InputText, {
              modelValue: _ctx.transferKeyword,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.transferKeyword) = $event)),
              modelModifiers: { trim: true },
              placeholder: "Transfer No",
              style: {"width":"15rem"},
              onKeyup: _cache[46] || (_cache[46] = _withKeys(($event: any) => (_ctx.loadInboundList(0)), ["enter"]))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Button, {
              icon: "pi pi-search",
              class: "p-button-primary p-mr-1 p-ml-1",
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.loadInboundList(0)))
            }),
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "p-button-info",
              onClick: _cache[48] || (_cache[48] = ($event: any) => {_ctx.transferKeyword = ''; _ctx.loadInboundList(0)})
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DataTable, {
          value: _ctx.inboundTransfers,
          lazy: true,
          first: _ctx.inboundFirst,
          "onUpdate:first": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.inboundFirst) = $event)),
          paginator: true,
          rows: _ctx.transferLimit,
          totalRecords: _ctx.inboundTotal,
          onPage: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onInboundPage($event))),
          class: "p-datatable-sm p-datatable-striped p-datatable-gridlines"
        }, {
          empty: _withCtx(() => [
            _hoisted_125
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "transfer_no",
              header: "Transfer No"
            }),
            _createVNode(_component_Column, { header: "From Branch" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(s.data.from_branch?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Status" }, {
              body: _withCtx((s) => [
                _createElementVNode("span", {
                  style: _normalizeStyle({
                        background: _ctx.transferStatusColor(s.data.status),
                        color:'#fff', padding:'2px 6px', borderRadius:'4px', fontSize:'0.8rem'
                    })
                }, _toDisplayString(s.data.status), 5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Items" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(s.data.merged_item_count ?? s.data.items?.length ?? 0) + " item(s)", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Cost Value" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.total_cost_value).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Transfer Date" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(_ctx.formatExpiry(s.data.transfer_date)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Actioned By" }, {
              body: _withCtx((s) => [
                (s.data.status === 'Cancelled' && s.data.cancel_history)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_126, [
                      _createTextVNode(_toDisplayString(s.data.cancel_history.user?.name ?? '-') + " ", 1),
                      _createElementVNode("span", _hoisted_127, " (" + _toDisplayString(s.data.cancel_history.action === 'CancelledByReceiver' ? s.data.to_branch?.name : s.data.from_branch?.name) + ") ", 1)
                    ]))
                  : (s.data.status === 'Requested' && s.data.initiated_by_user)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_128, [
                        _createTextVNode(_toDisplayString(s.data.initiated_by_user.name) + " ", 1),
                        _createElementVNode("span", _hoisted_129, " (" + _toDisplayString(s.data.from_branch?.name) + ") ", 1)
                      ]))
                    : (s.data.status === 'InTransit' && s.data.dispatched_by_user)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_130, [
                          _createTextVNode(_toDisplayString(s.data.dispatched_by_user.name) + " ", 1),
                          _createElementVNode("span", _hoisted_131, " (" + _toDisplayString(s.data.from_branch?.name) + ") ", 1)
                        ]))
                      : (s.data.status === 'Discrepancy' && s.data.received_by_user)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_132, [
                            _createTextVNode(_toDisplayString(s.data.received_by_user.name) + " ", 1),
                            _createElementVNode("span", _hoisted_133, " (" + _toDisplayString(s.data.to_branch?.name) + ") ", 1)
                          ]))
                        : (s.data.status === 'Declined' && s.data.declined_by_user)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_134, [
                              _createTextVNode(_toDisplayString(s.data.declined_by_user.name) + " ", 1),
                              _createElementVNode("span", _hoisted_135, " (" + _toDisplayString(s.data.to_branch?.name) + ") ", 1)
                            ]))
                          : (s.data.status === 'Approved' && s.data.approved_by_user)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_136, [
                                _createTextVNode(_toDisplayString(s.data.approved_by_user.name) + " ", 1),
                                _createElementVNode("span", _hoisted_137, " (" + _toDisplayString(s.data.to_branch?.name) + ") ", 1)
                              ]))
                            : (s.data.status === 'Completed' && s.data.completed_history?.user)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_138, [
                                  _createTextVNode(_toDisplayString(s.data.completed_history.user.name) + " ", 1),
                                  _createElementVNode("span", _hoisted_139, " (" + _toDisplayString(s.data.completed_history.user.branch?.name ?? s.data.from_branch?.name) + ") ", 1)
                                ]))
                              : (s.data.initiated_by_user)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_140, [
                                    _createTextVNode(_toDisplayString(s.data.initiated_by_user.name) + " ", 1),
                                    _createElementVNode("span", _hoisted_141, " (" + _toDisplayString(s.data.from_branch?.name) + ") ", 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_142, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Actions" }, {
              body: _withCtx((s) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-eye",
                  class: "p-button-rounded p-button-info p-mr-1",
                  title: "View Detail",
                  onClick: ($event: any) => (_ctx.viewTransferDetail(s.data))
                }, null, 8, ["onClick"]),
                (s.data.status === 'Requested')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-check",
                      class: "p-button-rounded p-button-success p-mr-1",
                      title: "Approve Transfer",
                      onClick: ($event: any) => (_ctx.approveTransfer(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'Requested')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-danger p-mr-1",
                      title: "Decline Transfer",
                      onClick: ($event: any) => (_ctx.openDeclineDialog(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (s.data.status === 'Approved')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-danger p-mr-1",
                      title: "Only the sending branch can cancel an approved transfer",
                      disabled: true
                    }))
                  : _createCommentVNode("", true),
                (s.data.status === 'InTransit')
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 3,
                      icon: "pi pi-check-circle",
                      class: "p-button-rounded p-button-success p-mr-1",
                      title: "Receive Stock",
                      onClick: ($event: any) => (_ctx.openReceiveDialog(s.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "first", "rows", "totalRecords"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.declineDialog,
      "onUpdate:visible": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.declineDialog) = $event)),
      style: { width: '500px' },
      header: "Decline Transfer Request",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.declineDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Decline Transfer",
          icon: "pi pi-times",
          class: "p-button-warning",
          onClick: _ctx.submitDecline,
          disabled: !_ctx.declineReason.trim()
        }, null, 8, ["onClick", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_143, [
          _createElementVNode("div", _hoisted_144, [
            _hoisted_145,
            _createVNode(_component_Textarea, {
              modelValue: _ctx.declineReason,
              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.declineReason) = $event)),
              rows: "4",
              placeholder: "Enter reason for declining this transfer request...",
              style: {"width":"100%"}
            }, null, 8, ["modelValue"]),
            (!_ctx.declineReason.trim())
              ? (_openBlock(), _createElementBlock("small", _hoisted_146, "Reason is required."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.cancelDialog,
      "onUpdate:visible": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.cancelDialog) = $event)),
      style: { width: '500px' },
      header: "Cancel Transfer",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.cancelDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Cancel Transfer",
          icon: "pi pi-times",
          class: "p-button-warning",
          onClick: _ctx.submitCancel,
          disabled: !_ctx.cancelReason.trim()
        }, null, 8, ["onClick", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_147, [
          _createElementVNode("div", _hoisted_148, [
            _hoisted_149,
            _createVNode(_component_Textarea, {
              modelValue: _ctx.cancelReason,
              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.cancelReason) = $event)),
              rows: "4",
              placeholder: "Enter reason for cancelling this transfer...",
              style: {"width":"100%"}
            }, null, 8, ["modelValue"]),
            (!_ctx.cancelReason.trim())
              ? (_openBlock(), _createElementBlock("small", _hoisted_150, "Reason is required."))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.dispatchDialog,
      "onUpdate:visible": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.dispatchDialog) = $event)),
      style: { width: '80vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Dispatch Stock",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.dispatchDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Confirm Dispatch",
          icon: "pi pi-send",
          class: "p-button-success",
          onClick: _ctx.submitDispatch
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.dispatchingTransfer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
              _hoisted_152,
              _createTextVNode(" " + _toDisplayString(_ctx.dispatchingTransfer.transfer_no) + "  |  ", 1),
              _hoisted_153,
              _createTextVNode(" " + _toDisplayString(_ctx.dispatchingTransfer.to_branch?.name) + "  |  ", 1),
              _hoisted_154,
              _createTextVNode(" " + _toDisplayString(_ctx.dispatchingTransfer.status), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataTable, {
          value: _ctx.dispatchItems,
          class: "p-datatable-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "product_name",
              header: "Product"
            }),
            _createVNode(_component_Column, {
              field: "batch_no",
              header: "Batch No"
            }),
            _createVNode(_component_Column, { header: "Paid Qty" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.paid_qty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Free Qty" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.free_qty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Purchase Price" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.purchase_price).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Est. Cost" }, {
              body: _withCtx((s) => [
                _createElementVNode("b", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.paid_qty * s.data.purchase_price).toFixed(2)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("div", _hoisted_155, " Total: " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(_ctx.dispatchItems.reduce((sum, i) => sum + i.paid_qty * i.purchase_price, 0)).toFixed(2)), 1)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.returnDialog,
      "onUpdate:visible": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.returnDialog) = $event)),
      style: { width: '80vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Return Transfer",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.returnDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Submit Return Request",
          icon: "pi pi-replay",
          class: "p-button-warning",
          onClick: _ctx.submitReturn
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.returningTransfer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
              _hoisted_157,
              _createTextVNode(" " + _toDisplayString(_ctx.returningTransfer.transfer_no) + "  |  ", 1),
              _hoisted_158,
              _createTextVNode(" " + _toDisplayString(_ctx.returningTransfer.from_branch?.name), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_159,
        _createVNode(_component_DataTable, {
          value: _ctx.returnItems,
          class: "p-datatable-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "product_name",
              header: "Product"
            }),
            _createVNode(_component_Column, {
              field: "batch_no",
              header: "Batch No"
            }),
            _createVNode(_component_Column, { header: "Received Qty" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.received_qty).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Return Qty" }, {
              body: _withCtx((s) => [
                _createVNode(_component_InputNumber, {
                  modelValue: s.data.qty,
                  "onUpdate:modelValue": ($event: any) => ((s.data.qty) = $event),
                  min: 0,
                  max: s.data.received_qty,
                  useGrouping: false,
                  style: {"width":"7rem"},
                  class: _normalizeClass({ 'p-invalid': !!s.data.qtyError }),
                  onBlur: () => {
                            if (s.data.qty < 0) s.data.qtyError = 'Cannot be negative.';
                            else if (s.data.qty > s.data.received_qty) s.data.qtyError = 'Max ' + s.data.received_qty;
                            else s.data.qtyError = '';
                        }
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "class", "onBlur"]),
                (s.data.qtyError)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_160, _toDisplayString(s.data.qtyError), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Item Notes" }, {
              body: _withCtx((s) => [
                _createVNode(_component_InputText, {
                  modelValue: s.data.notes,
                  "onUpdate:modelValue": ($event: any) => ((s.data.notes) = $event),
                  placeholder: "Reason for returning this item...",
                  style: {"width":"100%"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("div", _hoisted_161, [
          _hoisted_162,
          _createVNode(_component_InputText, {
            modelValue: _ctx.returnNotes,
            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.returnNotes) = $event)),
            placeholder: "Overall return notes..."
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.discrepancyConfirmDialog,
      "onUpdate:visible": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.discrepancyConfirmDialog) = $event)),
      style: { width: '80vw' },
      position: "top",
      class: "p-fluid p-m-0 p-dialog-maximized",
      header: "Confirm Discrepancy",
      modal: true,
      closeOnEscape: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          class: "p-button-danger",
          onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.discrepancyConfirmDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Confirm & Record Loss",
          icon: "pi pi-check",
          class: "p-button-warning",
          onClick: _ctx.submitDiscrepancyCompletion
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.discrepancyConfirmTransfer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
              _hoisted_164,
              _createTextVNode(" " + _toDisplayString(_ctx.discrepancyConfirmTransfer.transfer_no) + "  |  ", 1),
              _hoisted_165,
              _createTextVNode(" " + _toDisplayString(_ctx.discrepancyConfirmTransfer.to_branch?.name), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataTable, {
          value: _ctx.discrepancyConfirmItems,
          class: "p-datatable-sm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "Product" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(s.data.product?.product_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "batch_no",
              header: "Batch No"
            }),
            _createVNode(_component_Column, { header: "Sent" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.sent_qty).toFixed(0)) + " (P:" + _toDisplayString(Number(s.data.sent_paid_qty).toFixed(0)) + " F:" + _toDisplayString(Number(s.data.sent_free_qty).toFixed(0)) + ") ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Received" }, {
              body: _withCtx((s) => [
                (s.data.received_qty != null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_166, _toDisplayString(Number(s.data.received_qty).toFixed(0)) + " (P:" + _toDisplayString(Number(s.data.received_paid_qty).toFixed(0)) + " F:" + _toDisplayString(Number(s.data.received_free_qty).toFixed(0)) + ") ", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_167, "Pending"))
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Missing" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.missing_qty ?? 0).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Damaged" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(Number(s.data.damaged_qty ?? 0).toFixed(0)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Purchase Price" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.purchase_price).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Paid Loss" }, {
              body: _withCtx((s) => [
                _createElementVNode("b", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(s.data.paid_loss_amt).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Notes" }, {
              body: _withCtx((s) => [
                _createTextVNode(_toDisplayString(s.data.discrepancy_notes ?? '-'), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("div", _hoisted_168, [
          _hoisted_169,
          _createVNode(_component_Textarea, {
            modelValue: _ctx.discrepancyConfirmNotes,
            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.discrepancyConfirmNotes) = $event)),
            rows: "3",
            placeholder: "Notes for this discrepancy confirmation..."
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_170, " Total Paid Loss: " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(Number(_ctx.discrepancyConfirmLoss).toFixed(2)), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}